import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import LoadingSpinner from "../utils/LoadingSpinner";
import api from "../api/api";

// component exists only for older bookmarked links
// not used in React App!
class DetailRedirectToLatest extends Component {
  componentDidMount() {
    this.fetchData();
  }
  fetchData() {
    api.fetchAllDispositionen(this.props.match.params.id).subscribe(result => {
      // neuste Massnahme wählen
      this.props.history.push(`/detail/${result.recent}`);
    });
  }
  render() {
    return (
      <div>
        <LoadingSpinner loading={true} />
      </div>
    );
  }
}

export default withRouter(DetailRedirectToLatest);



// WEBPACK FOOTER //
// ./src/legacy/DetailRedirectToLatest.js